enum PaymentStatus {
    NotPaid = "NotPaid",
    Paid = "Paid",
    CashOnDelivery = "CashOnDelivery",
    Postponed = "Postponed",
    DUE = "DUE"
}

export default PaymentStatus;